import React, { useEffect, useContext } from "react";
import { Box, Button, Heading, Flex } from "@chakra-ui/react";
import { Formik, Form } from "formik";
import { UsersContext } from "../Context/UsersContext";
import CustomField from "../Common/Form/CustomField";

const UsersFilter = ({ role }) => {
  const { getUsers } = useContext(UsersContext);

  useEffect(() => {
    getUsers({ roleId: role });
  }, []);

  const handleSubmit = (values) => {
    let queries = { roleId: role };
    if (values.businessName) queries.businessName = values.businessName;
    if (values.zoneName) queries.zoneName = values.zoneName;
    getUsers(queries);
  };

  return (
    <>
      <Heading variant="h2">Filtros</Heading>

      <Box>
        <Formik
          initialValues={{ businessName: "" }}
          onSubmit={(values, actions) => {
            handleSubmit(values);
            actions.setSubmitting(false);
          }}
        >
          {(props) => (
            <Form>
              <Flex
                spacing="50px"
                align="left"
                flexDirection={["column", "column", "row"]}
                justifyContent="space-around"
              >
                <Box w={["auto", "25%"]}>
                  <CustomField
                    name="businessName"
                    title="Buscador"
                    placeholder="Ingrese un nombre"
                    props={props}
                    customFontColor="menu.700"
                  ></CustomField>
                </Box>

                <Box w={["auto", "25%"]}>
                  {role == 4 && (
                    <CustomField
                      name="zoneName"
                      title="Zonas"
                      placeholder="Ingrese una zona"
                      props={props}
                      customFontColor="menu.700"
                    ></CustomField>
                  )}
                </Box>
                <Box align="right">
                  <Button
                    mt={4}
                    colorScheme="teal"
                    isLoading={props.isSubmitting}
                    type="submit"
                  >
                    Buscar
                  </Button>
                </Box>
              </Flex>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default UsersFilter;
